import '../assets/NcAppSettingsDialog-DR46jcRG.css';
import { N as f } from "./NcDialog-D6YSjidf.mjs";
import p from "../Components/NcVNodes.mjs";
import { useIsMobile as m } from "../Composables/useIsMobile.mjs";
import { r as _, l as v, a as S } from "./_l10n-BZu8wI2q.mjs";
import k from "debounce";
import N from "vue";
import { n as C } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
_(v);
const y = {
  name: "NcAppSettingsDialog",
  components: {
    NcDialog: f,
    NcVNodes: p
  },
  provide() {
    return {
      registerSection: this.registerSection,
      unregisterSection: this.unregisterSection
    };
  },
  props: {
    /**
     * Determines the open / closed state of the modal
     */
    open: {
      type: Boolean,
      required: !0
    },
    /**
     * Shows the navigation on desktop if true
     */
    showNavigation: {
      type: Boolean,
      default: !1
    },
    /**
     * Selector for the popover container
     */
    container: {
      type: String,
      default: "body"
    },
    /**
     * Name of the settings
     */
    name: {
      type: String,
      default: ""
    },
    /**
     * Additional elements to add to the focus trap
     */
    additionalTrapElements: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:open"],
  setup() {
    return {
      isMobile: m()
    };
  },
  data() {
    return {
      selectedSection: "",
      linkClicked: !1,
      addedScrollListener: !1,
      scroller: null,
      /**
       * Currently registered settings sections
       * @type {{ id: string, name: string, icon?: import('vue').VNode[] }[]}
       */
      sections: []
    };
  },
  computed: {
    dialogProperties() {
      return {
        additionalTrapElements: this.additionalTrapElements,
        closeOnClickOutside: !0,
        class: "app-settings",
        container: this.container,
        contentClasses: "app-settings__content",
        size: "large",
        name: this.name,
        navigationClasses: "app-settings__navigation"
      };
    },
    /**
     * Check if one or more navigation entries provide icons
     */
    hasNavigationIcons() {
      return this.sections.some(({ icon: t }) => !!t);
    },
    hasNavigation() {
      return !(this.isMobile || !this.showNavigation);
    },
    settingsNavigationAriaLabel() {
      return S("Settings navigation");
    }
  },
  updated() {
    this.$refs.settingsScroller && (this.scroller = this.$refs.settingsScroller, this.addedScrollListener || (this.scroller.addEventListener("scroll", this.handleScroll), this.addedScrollListener = !0));
  },
  methods: {
    /**
     * Called when a new section is registered
     * @param {string} id The section ID
     * @param {string} name The section name
     * @param {import('vue').VNode[]|undefined} icon Optional icon component
     */
    registerSection(t, e, n) {
      if (this.sections.some(({ id: i }) => t === i))
        throw new Error("Duplicate section id found: ".concat(t, ". Settings navigation sections must have unique section ids."));
      this.sections.some(({ name: i }) => e === i) && N.util.warn("Duplicate section name found: ".concat(e, ". Settings navigation sections must have unique section names."));
      const o = [...this.sections, { id: t, name: e, icon: n }];
      this.sections = o.sort(({ id: i }, { id: s }) => {
        const r = (h) => {
          var a, c, d;
          return (d = (c = (a = this.$slots.default) == null ? void 0 : a.findIndex) == null ? void 0 : c.call(a, (l) => {
            var u, g;
            return ((g = (u = l == null ? void 0 : l.componentOptions) == null ? void 0 : u.propsData) == null ? void 0 : g.id) === h;
          })) != null ? d : -1;
        };
        return r(i) - r(s);
      }), this.sections.length === 1 && (this.selectedSection = t);
    },
    /**
     * Called when a section is unregistered to remove it from dialog
     * @param {string} id The section ID
     */
    unregisterSection(t) {
      var e, n;
      this.sections = this.sections.filter(({ id: o }) => t !== o), this.selectedSection === t && (this.selectedSection = (n = (e = this.sections[0]) == null ? void 0 : e.id) != null ? n : "");
    },
    /**
     * Scrolls the content to the selected settings section.absolute
     *
     * @param {string} item the ID of the section
     */
    handleSettingsNavigationClick(t) {
      this.linkClicked = !0, document.getElementById("settings-section_" + t).scrollIntoView({
        behavior: "smooth",
        inline: "nearest"
      }), this.selectedSection = t, setTimeout(() => {
        this.linkClicked = !1;
      }, 1e3);
    },
    handleCloseModal(t) {
      t || (this.$emit("update:open", !1), this.scroller.removeEventListener("scroll", this.handleScroll), this.addedScrollListener = !1, this.scroller.scrollTop = 0);
    },
    handleScroll() {
      this.linkClicked || this.unfocusNavigationItem();
    },
    // Remove selected section once the user starts scrolling
    unfocusNavigationItem: k(function() {
      this.selectedSection = "", document.activeElement.className.includes("navigation-list__link") && document.activeElement.blur();
    }, 300)
  }
};
var b = function() {
  var e = this, n = e._self._c;
  return e.open ? n("NcDialog", e._b({ attrs: { "navigation-aria-label": e.settingsNavigationAriaLabel }, on: { "update:open": e.handleCloseModal }, scopedSlots: e._u([e.hasNavigation ? { key: "navigation", fn: function({ isCollapsed: o }) {
    return [o ? e._e() : n("ul", { staticClass: "navigation-list" }, e._l(e.sections, function(i) {
      return n("li", { key: i.id }, [n("a", { class: {
        "navigation-list__link": !0,
        "navigation-list__link--active": i.id === e.selectedSection,
        "navigation-list__link--icon": e.hasNavigationIcons
      }, attrs: { "aria-current": "".concat(i.id === e.selectedSection), href: "#settings-section_".concat(i.id), tabindex: "0" }, on: { click: function(s) {
        return s.preventDefault(), e.handleSettingsNavigationClick(i.id);
      }, keydown: function(s) {
        return !s.type.indexOf("key") && e._k(s.keyCode, "enter", 13, s.key, "Enter") ? null : e.handleSettingsNavigationClick(i.id);
      } } }, [e.hasNavigationIcons ? n("div", { staticClass: "navigation-list__link-icon" }, [i.icon ? n("NcVNodes", { attrs: { vnodes: i.icon } }) : e._e()], 1) : e._e(), n("span", { staticClass: "navigation-list__link-text" }, [e._v(" " + e._s(i.name) + " ")])])]);
    }), 0)];
  } } : null], null, !0) }, "NcDialog", e.dialogProperties, !1), [n("div", { ref: "settingsScroller" }, [e._t("default")], 2)]) : e._e();
}, E = [], D = /* @__PURE__ */ C(
  y,
  b,
  E,
  !1,
  null,
  "3e0025d1",
  null,
  null
);
const O = D.exports;
export {
  O as N
};
